import type en from '../en/rental'
import type { Translation } from '../types'

/** Rental */
const rental: Translation<typeof en> = {
  "rental.title": "Verhuur",
  "rental.subtitle": "Voorraad, planning, evenementen en inkoop",
  "rental.sections": "Onderdelen van verhuur",
  "rental.tab.planning": "Planning",
  "rental.tab.events": "Evenementen",
  "rental.tab.customers": "Klanten",
  "rental.tab.stock": "Voorraad",
  "rental.tab.suppliers": "Leveranciers",
  "rental.tab.purchasing": "Inkoop",
  "rental.search": "Zoeken",
  "rental.notes": "Opmerkingen",
  "rental.details": "Gegevens",
  "rental.saveFailed": "Opslaan is niet gelukt",
  "rental.amountInvalid": "Een bedrag is geen getal, zoals 12,50",
  "rental.percentInvalid": "Een percentage is een getal van 0 tot 100",
  "rental.stock.sections": "Onderdelen van de voorraad",
  "rental.stock.articles": "Artikelen",
  "rental.stock.items": "Inventaris",
  "rental.stock.warehouses": "Magazijnen",
  "rental.stock.transfers": "Verplaatsingen",
  "rental.stock.categories": "Categorieën",
  "rental.article.add": "Artikel toevoegen",
  "rental.article.edit": "Artikel wijzigen",
  "rental.article.save": "Artikel opslaan",
  "rental.article.saved": "Artikel opgeslagen",
  "rental.article.deleted": "Artikel verwijderd",
  "rental.article.deleteConfirm": "Het artikel {name} verwijderen? Een artikel met items, voorraad of regels kan niet worden verwijderd: zet het dan op inactief.",
  "rental.article.empty": "Nog geen artikelen",
  "rental.article.sku": "Artikelnummer",
  "rental.article.name": "Naam",
  "rental.article.description": "Omschrijving",
  "rental.article.category": "Categorie",
  "rental.article.allCategories": "Alle categorieën",
  "rental.article.showInactive": "Inactieve tonen",
  "rental.article.inactive": "Inactief",
  "rental.article.active": "Actief (kan op evenementen)",
  "rental.article.perItem": "Per item (serienummer)",
  "rental.article.bulk": "Aantal (bulk)",
  "rental.article.dayPrice": "Dagprijs",
  "rental.article.weekendPrice": "Weekendprijs",
  "rental.article.weekPrice": "Weekprijs",
  "rental.article.fromDayPrice": "Leeg: uit de dagprijs",
  "rental.article.vatRate": "Btw (%)",
  "rental.article.vatDefault": "Leeg: het standaardtarief van het bedrijf",
  "rental.article.vatDefaultShort": "standaard",
  "rental.article.purchasePrice": "Inkoopprijs",
  "rental.article.externalCode": "Code in de facturatiesoftware",
  "rental.article.prices": "Prijzen exclusief btw",
  "rental.article.stock": "Voorraad",
  "rental.article.noStock": "Niets op voorraad",
  "rental.item.add": "Item toevoegen",
  "rental.item.save": "Item opslaan",
  "rental.item.saved": "Item opgeslagen",
  "rental.item.empty": "Geen items",
  "rental.item.serial": "Serienummer",
  "rental.item.mac": "MAC-adres",
  "rental.item.tag": "Tag",
  "rental.item.tagHint": "De NFC-tag of QR-code (nu nog niet verplicht)",
  "rental.item.article": "Artikel",
  "rental.item.warehouse": "Magazijn",
  "rental.item.status": "Status",
  "rental.item.statusOf": "Status van {name}",
  "rental.item.historyOf": "Geschiedenis van {name}",
  "rental.item.allArticles": "Alle artikelen",
  "rental.item.allWarehouses": "Alle magazijnen",
  "rental.item.allStatuses": "Elke status",
  "rental.bulk.title": "Aantal per magazijn",
  "rental.bulk.count": "Tellen",
  "rental.bulk.countOf": "{name} tellen",
  "rental.bulk.counted": "Geteld",
  "rental.bulk.note": "Waarom (optioneel)",
  "rental.bulk.save": "Telling opslaan",
  "rental.bulk.saved": "Telling opgeslagen",
  "rental.bulk.quantity": "Aantal",
  "rental.bulk.packed": "Waarvan in koffers",
  "rental.warehouse.add": "Magazijn toevoegen",
  "rental.warehouse.edit": "Magazijn wijzigen",
  "rental.warehouse.editOf": "{name} wijzigen",
  "rental.warehouse.save": "Magazijn opslaan",
  "rental.warehouse.saved": "Magazijn opgeslagen",
  "rental.warehouse.deleted": "Magazijn verwijderd",
  "rental.warehouse.deleteOf": "{name} verwijderen",
  "rental.warehouse.deleteConfirm": "Het magazijn {name} verwijderen? Alleen een leeg magazijn zonder evenementen kan worden verwijderd.",
  "rental.warehouse.empty": "Nog geen magazijnen: voeg het eerste toe",
  "rental.warehouse.name": "Naam",
  "rental.warehouse.address": "Adres",
  "rental.warehouse.default": "Thuismagazijn",
  "rental.warehouse.makeDefault": "Thuismagazijn maken",
  "rental.warehouse.makeDefaultOf": "{name} het thuismagazijn maken",
  "rental.transfer.add": "Nieuwe verplaatsing",
  "rental.transfer.save": "Verplaatsen",
  "rental.transfer.done": "Verplaatst",
  "rental.transfer.empty": "Nog geen verplaatsingen",
  "rental.transfer.from": "Van",
  "rental.transfer.to": "Naar",
  "rental.transfer.when": "Wanneer",
  "rental.transfer.fromTo": "Van → naar",
  "rental.transfer.what": "Wat",
  "rental.transfer.by": "Door",
  "rental.transfer.bulk": "Aantallen",
  "rental.transfer.noItems": "Geen losse items of stukken in dit magazijn (wat in een stuk zit, gaat mee met het stuk)",
  "rental.transfer.summary": "Items en stukken: {items} · bulk: {bulk}",
  "rental.category.add": "Categorie toevoegen",
  "rental.category.name": "Naam van de categorie",
  "rental.category.saved": "Categorie opgeslagen",
  "rental.category.deleted": "Categorie verwijderd",
  "rental.category.renameOf": "{name} hernoemen",
  "rental.category.deleteOf": "{name} verwijderen",
  "rental.category.deleteConfirm": "De categorie {name} verwijderen? De artikelen blijven, zonder categorie.",
  "rental.category.empty": "Nog geen categorieën",
  "rental.history.title": "Geschiedenis",
  "rental.history.empty": "Er is nog niets gebeurd",
  "rental.history.quantity": { one: "{count} stuk", other: "{count} stuks" },
  "rental.history.item.status": "Status gewijzigd",
  "rental.history.bulk.count": "Geteld",
  "rental.history.transfer": "Verplaatsing",
  "rental.history.receipt": "Ontvangen",
  "rental.history.subrental.return": "Terug naar de leverancier",
  "rental.status.IN_STOCK": "Op voorraad",
  "rental.status.AT_EVENT": "Bij een evenement",
  "rental.status.IN_REPAIR": "In reparatie",
  "rental.status.LOST": "Kwijt",
  "rental.status.RETIRED": "Afgeschreven",
  "rental.status.RETURNED": "Terug naar de leverancier",
  "rental.status.REQUESTED": "Aangevraagd",
  "rental.status.RESERVED": "Gereserveerd",
  "rental.status.CONFIRMED": "Bevestigd",
  "rental.status.CLOSED": "Afgesloten",
  "rental.status.CANCELLED": "Geannuleerd",
  "rental.status.DRAFT": "Concept",
  "rental.status.AWAITING_APPROVAL": "Wacht op goedkeuring",
  "rental.status.SENT": "Verstuurd",
  "rental.status.PARTLY_RECEIVED": "Deels ontvangen",
  "rental.status.RECEIVED": "Ontvangen",
  "rental.customer.add": "Klant toevoegen",
  "rental.customer.edit": "Klant wijzigen",
  "rental.customer.save": "Klant opslaan",
  "rental.customer.saved": "Klant opgeslagen",
  "rental.customer.deleted": "Klant verwijderd",
  "rental.customer.deleteConfirm": "De klant {name} verwijderen? Een klant met evenementen kan niet worden verwijderd.",
  "rental.customer.empty": "Nog geen klanten",
  "rental.customer.name": "Naam",
  "rental.customer.contact": "Contactpersoon",
  "rental.customer.email": "E-mail",
  "rental.customer.phone": "Telefoon",
  "rental.customer.address": "Adres",
  "rental.customer.vatNumber": "Btw-nummer",
  "rental.customer.externalRef": "Code in de facturatiesoftware",
  "rental.customer.noEvents": "Nog geen evenementen",
  "rental.supplier.add": "Leverancier toevoegen",
  "rental.supplier.edit": "Leverancier wijzigen",
  "rental.supplier.save": "Leverancier opslaan",
  "rental.supplier.saved": "Leverancier opgeslagen",
  "rental.supplier.deleted": "Leverancier verwijderd",
  "rental.supplier.deleteConfirm": "De leverancier {name} verwijderen? Een leverancier met orders kan niet worden verwijderd.",
  "rental.supplier.empty": "Nog geen leveranciers",
  "rental.supplier.name": "Naam",
  "rental.supplier.contact": "Contactpersoon",
  "rental.supplier.email": "E-mail",
  "rental.supplier.phone": "Telefoon",
  "rental.supplier.address": "Adres",
  "rental.supplier.vatNumber": "Btw-nummer",
  "rental.supplier.language": "Taal",
  "rental.supplier.languageHint": "Hun orderbrieven en mails zijn in deze taal",
  "rental.supplier.orders": "Orders en aanvragen",
  "rental.supplier.noOrders": "Nog geen orders of aanvragen",
  "rental.settings.prices": "Prijzen",
  "rental.settings.method": "Hoe prijzen worden berekend",
  "rental.settings.method.STAFFEL": "Een dagprijs met een staffel",
  "rental.settings.method.STAFFEL.hint": "De dagprijs maal de factor voor het aantal dagen",
  "rental.settings.method.FIXED": "Vaste dag-, weekend- en weekprijzen",
  "rental.settings.method.FIXED.hint": "Binnen één weekend (vrijdag 12:00 tot maandag 12:00) de weekendprijs; anders weken en dagen, de dagen nooit meer dan een week",
  "rental.settings.staffel": "De staffel",
  "rental.settings.from": "Vanaf",
  "rental.settings.days": "Dagen",
  "rental.settings.daysTimes": "dagen:",
  "rental.settings.factor": "Factor",
  "rental.settings.dayPrice": "× de dagprijs",
  "rental.settings.addRow": "Regel toevoegen",
  "rental.settings.removeRow": "Deze regel verwijderen",
  "rental.settings.extraDay": "Elke dag na de laatste regel voegt toe (× de dagprijs)",
  "rental.settings.staffelInvalid": "Elke staffelregel heeft hele dagen en een factor zoals 1,5 nodig",
  "rental.settings.vat": "Standaard btw-tarief (%)",
  "rental.settings.currency": "Valuta",
  "rental.settings.fourEyes": "Iemand anders moet goedkeuren",
  "rental.settings.fourEyesHint": "Wie een inkooporder of bijhuuraanvraag maakt of aanbiedt, kan die niet goedkeuren",
  "rental.settings.letters": "Op brieven aan leveranciers",
  "rental.settings.lettersHint": "Het logo van het bedrijf staat boven de brief als het er een heeft",
  "rental.settings.letterName": "Statutaire naam",
  "rental.settings.letterAddress": "Adres",
  "rental.settings.letterVat": "Btw-nummer",
  "rental.settings.letterCoc": "KvK-nummer",
  "rental.settings.letterEmail": "E-mail",
  "rental.settings.letterPhone": "Telefoon",
  "rental.settings.save": "Verhuurinstellingen opslaan",
  "rental.settings.saved": "Verhuurinstellingen opgeslagen",
  "rental.event.add": "Nieuw evenement",
  "rental.event.edit": "Evenement wijzigen",
  "rental.event.save": "Evenement opslaan",
  "rental.event.saved": "Evenement opgeslagen",
  "rental.event.empty": "Nog geen evenementen",
  "rental.event.needed": "Kies de klant en de huurperiode",
  "rental.event.name": "Evenement",
  "rental.event.customer": "Klant",
  "rental.event.rentalStart": "Huur begint",
  "rental.event.rentalEnd": "Huur eindigt",
  "rental.event.rentalPeriod": "Huurperiode",
  "rental.event.materialPeriod": "Materiaal weg en terug",
  "rental.event.materialOut": "Materiaal weg",
  "rental.event.materialBack": "Materiaal terug",
  "rental.event.materialApart": "Materiaal gaat eerder weg of komt later terug dan de huur",
  "rental.event.warehouse": "Thuismagazijn",
  "rental.event.homeWarehouse": "Het thuismagazijn van het bedrijf",
  "rental.event.site": "Locatie",
  "rental.event.externalRef": "Offertenummer",
  "rental.event.total": "Totaal",
  "rental.event.short": "Tekort",
  "rental.event.reserve": "Reserveren",
  "rental.event.confirm": "Bevestigen",
  "rental.event.close": "Afsluiten",
  "rental.event.cancel": "Evenement annuleren",
  "rental.event.reopen": "Heropenen",
  "rental.event.cancelConfirm": "Het evenement {name} annuleren? Het houdt dan geen materiaal meer vast.",
  "rental.event.statusSaved": "Nu: {status}",
  "rental.line.title": "Regels",
  "rental.line.empty": "Nog geen regels: voeg hieronder een artikel toe",
  "rental.line.add": "Regel toevoegen",
  "rental.line.save": "Regel opslaan",
  "rental.line.saved": "Regel opgeslagen",
  "rental.line.deleted": "Regel verwijderd",
  "rental.line.editOf": "De regel van {name} wijzigen",
  "rental.line.deleteOf": "De regel van {name} verwijderen",
  "rental.line.deleteConfirm": "De regel van {name} verwijderen?",
  "rental.line.quantity": "Aantal",
  "rental.line.unitPrice": "Prijs per stuk",
  "rental.line.calculated": "berekend {price}",
  "rental.line.customPrice": "Eigen prijs per stuk",
  "rental.line.customHint": "Leeg: de berekende {price}",
  "rental.line.availability": "Vrij en tekort",
  "rental.line.shortBy": "Tekort {count}",
  "rental.line.free": "Vrij: {free} (als uitstaande offertes vervallen: {fall})",
  "rental.line.subrented": "{count} bijgehuurd",
  "rental.line.expected": "{count} verwacht",
  "rental.line.requested": "{count} aangevraagd, nog niet bevestigd",
  "rental.line.transferFrom": "Verplaatsen vanuit {name}",
  "rental.discount.title": "Korting",
  "rental.discount.type": "Soort",
  "rental.discount.none": "Geen",
  "rental.discount.percent": "Een percentage",
  "rental.discount.amount": "Een bedrag",
  "rental.discount.value": "Bedrag",
  "rental.discount.save": "Korting opslaan",
  "rental.discount.saved": "Korting opgeslagen",
  "rental.totals.title": "Totalen",
  "rental.totals.subtotal": "Subtotaal",
  "rental.totals.discount": "Korting",
  "rental.totals.vat": "Btw {rate}",
  "rental.totals.total": "Totaal",
  "rental.planning.table": "Planning",
  "rental.planning.span": "Periode",
  "rental.planning.day": "Dag",
  "rental.planning.week": "Week",
  "rental.planning.month": "Maand",
  "rental.planning.date": "Datum",
  "rental.planning.previous": "Vorige",
  "rental.planning.next": "Volgende",
  "rental.planning.today": "Vandaag",
  "rental.planning.cell": "{article}, {day}: {free} vrij, {held} vastgehouden",
  "rental.planning.cellShort": "— {count} tekort",
  "rental.planning.shortEvents": "Evenementen met tekort",
  "rental.planning.noneShort": "Niets tekort in deze periode",
  "rental.planning.owned": "In bezit",
  "rental.planning.subrented": "Bijgehuurd",
  "rental.planning.expected": "Verwacht",
  "rental.planning.from": "Vanaf",
  "rental.planning.held": "Vastgehouden",
  "rental.planning.free": "Vrij",
  "rental.order.purchaseOrders": "Inkooporders",
  "rental.order.subRentals": "Bijhuur",
  "rental.order.purchaseOrder": "Inkooporder",
  "rental.order.subRental": "Bijhuur",
  "rental.order.newPurchase": "Nieuwe inkooporder",
  "rental.order.newSubRental": "Nieuwe bijhuur",
  "rental.order.savePurchase": "Inkooporder opslaan",
  "rental.order.saveSubRental": "Bijhuur opslaan",
  "rental.order.purchaseSaved": "Inkooporder opgeslagen",
  "rental.order.subRentalSaved": "Bijhuur opgeslagen",
  "rental.order.edit": "{number} wijzigen",
  "rental.order.editShort": "Wijzigen",
  "rental.order.deleted": "Verwijderd",
  "rental.order.deleteConfirm": "Het concept {number} verwijderen?",
  "rental.order.empty": "Hier staat nog niets",
  "rental.order.number": "Nummer",
  "rental.order.supplier": "Leverancier",
  "rental.order.warehouse": "Ontvangend magazijn",
  "rental.order.expected": "Verwachte levering",
  "rental.order.window": "Huurperiode",
  "rental.order.from": "Vanaf",
  "rental.order.to": "Tot",
  "rental.order.forEvent": "Voor het evenement",
  "rental.order.notes": "Opmerkingen voor de leverancier",
  "rental.order.supplierCode": "Code van de leverancier",
  "rental.order.unitPrice": "Prijs per stuk",
  "rental.order.unitCost": "Kosten per stuk",
  "rental.order.received": "Tot nu toe ontvangen",
  "rental.order.items": "Geregistreerde items",
  "rental.order.madeBy": "Gemaakt door",
  "rental.order.askedBy": "Goedkeuring gevraagd door",
  "rental.order.approvedBy": "Goedgekeurd door",
  "rental.order.sentTo": "Verstuurd naar",
  "rental.order.askApproval": "Goedkeuring vragen",
  "rental.order.approve": "Goedkeuren",
  "rental.order.sendAgain": "Opnieuw versturen",
  "rental.order.recordConfirmation": "Bevestiging vastleggen",
  "rental.order.registerItems": "Items registreren",
  "rental.order.saveItems": "Items opslaan",
  "rental.order.itemsSaved": "Items geregistreerd",
  "rental.order.allRegistered": "Alles geregistreerd",
  "rental.order.close": "Bijhuur afsluiten",
  "rental.order.closeConfirm": "Afsluiten? De geregistreerde items gaan terug naar de leverancier.",
  "rental.order.receive": "Ontvangen",
  "rental.order.receiveLine": "{name}: {received} van {quantity} ontvangen, nu",
  "rental.order.serialOf": "Serienummer {n}",
  "rental.order.saveReceipt": "Ontvangst opslaan",
  "rental.order.receiptSaved": "Ontvangst opgeslagen",
  "rental.order.newExpected": "Nieuwe verwachte dag",
  "rental.order.saveExpected": "Dag opslaan",
  "rental.order.expectedSaved": "Verwachte dag opgeslagen",
  "rental.order.cancelOrder": "Order annuleren",
  "rental.order.cancelRequest": "Aanvraag annuleren",
  "rental.order.cancelConfirm": "{number} annuleren?",
  "rental.order.pdf": "Pdf downloaden",
  "rental.order.waiting": "Wacht op iemand die mag goedkeuren",
  "rental.order.someoneElse": "Iemand anders moet dit goedkeuren",
  "rental.order.notSent": "Goedgekeurd, niet verstuurd",
  "rental.order.notSentReason": "Goedgekeurd, maar de mail aan de leverancier is niet verstuurd: {reason}",
  "rental.order.done.request-approval": "Ter goedkeuring aangeboden",
  "rental.order.done.approve": "Goedgekeurd en verstuurd",
  "rental.order.done.send": "Verstuurd naar de leverancier",
  "rental.order.done.cancel": "Geannuleerd",
  "rental.order.done.confirm": "Bevestiging vastgelegd",
  "rental.order.done.close": "Afgesloten: de items zijn terug",
  "rental.order.byHandHint": "Download de pdf en stuur hem zelf naar de leverancier; markeer de order daarna als verstuurd.",
  "rental.order.markSent": "Markeren als verstuurd",
  "rental.order.markSentConfirm": "{number} markeren als verstuurd? Doe dit zodra de leverancier de brief heeft.",
  "rental.order.done.mark-sent": "Gemarkeerd als verstuurd",
  "rental.order.sentByHand": "Met de hand, gemarkeerd door {name} · {when}",
  "rental.article.kind": "Soort",
  "rental.article.kit": "Kit",
  "rental.article.container": "Koffer",
  "rental.article.kindHint.ITEM": "Elk item heeft een eigen serienummer of tag",
  "rental.article.kindHint.BULK": "Geteld, niet per stuk (kabels, adapters)",
  "rental.article.kindHint.KIT": "Bij verhuur samengesteld uit andere artikelen (het recept); geen eigen voorraad",
  "rental.article.kindHint.CONTAINER": "Een koffer of set waarvan elk stuk andere artikelen bevat (elk stuk heeft een eigen code)",
  "rental.kit.noStock": "Een kit heeft geen eigen voorraad: bij verhuur wordt hij samengesteld uit zijn onderdelen.",
  "rental.item.kind": "Soort",
  "rental.item.allKinds": "Items en stukken",
  "rental.item.kindPlain": "Items",
  "rental.item.kindPieces": "Stukken van koffers",
  "rental.item.piece": "In stuk",
  "rental.item.device": "Apparaat",
  "rental.recipe.title": "Recept",
  "rental.recipe.kitHint": "Wat één kit bevat. Een evenementregel van N kits reserveert N keer elk onderdeel.",
  "rental.recipe.containerHint": "Wat elk stuk hoort te bevatten. Een stuk met iets anders erin wordt als onvolledig getoond.",
  "rental.recipe.empty": "Nog geen onderdelen",
  "rental.recipe.part": "Onderdeel",
  "rental.recipe.quantity": "Aantal",
  "rental.recipe.add": "Onderdeel toevoegen",
  "rental.recipe.removeOf": "{name} uit het recept halen",
  "rental.recipe.saved": "Recept opgeslagen",
  "rental.piece.title": "Stukken",
  "rental.piece.add": "Stuk toevoegen",
  "rental.piece.edit": "Stuk wijzigen",
  "rental.piece.save": "Stuk opslaan",
  "rental.piece.saved": "Stuk opgeslagen",
  "rental.piece.code": "Code",
  "rental.piece.contents": "Inhoud",
  "rental.piece.empty": "Nog geen stukken",
  "rental.piece.complete": "Compleet",
  "rental.piece.incomplete": "Onvolledig",
  "rental.piece.notRecipe": "Niet volgens het recept:",
  "rental.piece.missing": "ontbreekt: {count} × {name}",
  "rental.piece.extra": "te veel: {count} × {name}",
  "rental.piece.nothing": "Leeg",
  "rental.piece.addItem": "Item toevoegen",
  "rental.piece.addBulk": "Bulk toevoegen",
  "rental.piece.addDevice": "Apparaat toevoegen",
  "rental.piece.addOne": "Toevoegen",
  "rental.piece.item": "Item",
  "rental.piece.noItems": "Geen losse items op voorraad in dit magazijn",
  "rental.piece.takeOut": "Eruit halen",
  "rental.piece.takeOutOf": "{name} eruit halen",
  "rental.piece.contentsSaved": "Inhoud opgeslagen",
  "rental.device.search": "Serienummer, MAC of naam",
  "rental.device.searchHint": "Tussen de apparaten van het dashboard op de locaties die u mag zien",
  "rental.device.none": "Geen apparaat gevonden",
  "rental.device.pick": "Kiezen",
  "rental.device.pickOf": "{name} kiezen",
  "rental.device.inInventory": "Staat al in de inventaris",
  "rental.device.takenByOther": "Gekoppeld aan een ander item",
  "rental.device.other": "Ander apparaat",
  "rental.device.article": "Artikel van het item",
  "rental.device.articleHint": "Nog niet in de inventaris: het wordt een item van dit artikel",
  "rental.device.hidden": "Op een locatie die u niet kunt zien",
  "rental.device.tie": "Aan apparaat koppelen",
  "rental.device.tieOf": "{name} aan een apparaat koppelen",
  "rental.device.tied": "Apparaat gekoppeld",
  "rental.device.untie": "Apparaat loskoppelen",
  "rental.device.untieOf": "Apparaat van {name} loskoppelen",
  "rental.device.untieConfirm": "Het apparaat van {name} loskoppelen? Het item blijft in de inventaris.",
  "rental.device.untied": "Apparaat losgekoppeld",
  "rental.line.incomplete": { one: "{count} van de vrije stukken is onvolledig", other: "{count} van de vrije stukken zijn onvolledig" },
  "rental.line.perKit": "{count} per kit",
  "rental.planning.kitDay": "Een kit heeft geen eigen voorraad: dit zijn de kits die de onderdelen toelaten op het laagste moment van de dag.",
  "rental.order.expectedHint": "Telt als verwacht vanaf het begin van deze dag",
  "rental.recipe.quantityOf": "Aantal {name}",
  "rental.item.kindItem": "Item",
  "rental.device.lastSeen": "Laatst gezien {when}",
  "rental.history.item.piece.in": "In een stuk gestopt",
  "rental.history.item.piece.out": "Uit een stuk gehaald",
  "rental.history.bulk.piece": "Bulk in een stuk",
  "rental.history.device.tie": "Aan apparaat gekoppeld",
  "rental.history.device.untie": "Apparaat losgekoppeld",
  "rental.event.comment": "Opmerking",
  "rental.event.commentPlaceholder": "Een notitie voor iedereen bij dit evenement: de klant, de planners, de monteurs",
  "rental.event.commentBy": "Laatst gewijzigd door {name}, {when}",
  "rental.event.saveComment": "Opmerking bewaren",
  "rental.event.commentSaved": "Opmerking bewaard",
  "rental.load.title": "Laden",
  "rental.load.scan": "Scan of typ een code",
  "rental.load.scanHint": "Een tag, stukcode, serienummer of MAC: een scanner typt het en drukt op Enter",
  "rental.load.mode": "Wat een scan doet",
  "rental.load.modeLoad": "Laden",
  "rental.load.modeReturn": "Terug: {status}",
  "rental.load.loaded": "Geladen: {name}",
  "rental.load.returned": "Terug: {name}",
  "rental.load.failed": "Niet geladen",
  "rental.load.returnFailed": "Niet teruggezet",
  "rental.load.count": "{out} van {quantity} weg",
  "rental.load.byHand": "Met de hand toevoegen",
  "rental.load.byHandOf": "Met de hand toevoegen: {name}",
  "rental.load.empty": "Nog niets geladen",
  "rental.load.out": "Weg",
  "rental.load.when": "{when} · {who}",
  "rental.load.return": "Terugzetten",
  "rental.load.returnOf": "{name} terugzetten",
  "rental.load.part": "Onderdeel van de kit",
  "rental.load.choose": "Item of stuk",
  "rental.load.none": "Hiervan is niets vrij in het magazijn van het evenement",
  "rental.load.quantity": "Aantal",
  "rental.load.load": "Laden",
  "rental.load.missing": "Ontbreekt in het stuk (kwijt)",
  "rental.load.cameBack": "Teruggekomen",
  "rental.load.cameBackHint": "Van {count} weg; de rest wordt als kwijt geboekt",
  "rental.settings.archiveDays": "Evenementlocatie bewaren na afsluiten (dagen)",
  "rental.settings.archiveDaysHint": "Gearchiveerd, daarna na zoveel dagen verwijderd (1–3650)",
  "rental.load.cameBackOf": "{back} van {out} terug",
  "rental.bulk.out": "Waarvan bij evenementen",
  "rental.bulk.countedHint": "Wat nu in dit magazijn is, ook in koffers; wat bij evenementen is, komt erbij",
  "rental.people.title": "Klantpersonen",
  "rental.people.hint": "Personen van deze klant die inloggen om hun evenementen te zien: de data, de apparatuur ter plaatse en hoe die erbij staat, en de opmerking",
  "rental.people.email": "E-mailadres",
  "rental.people.name": "Naam (optioneel)",
  "rental.people.only": "Alleen tijdens het evenement",
  "rental.people.onlyHint": "Inloggen kan alleen van materiaal uit tot materiaal terug van een van hun evenementen",
  "rental.people.onlyFixed": "U hebt dit zelf, dus de mensen die u uitnodigt krijgen het ook",
  "rental.people.main": "Hoofdcontactpersoon",
  "rental.people.mainHint": "Mag anderen van deze klant uitnodigen en verwijderen",
  "rental.people.invite": "Uitnodigen",
  "rental.people.invited": "Uitnodiging verstuurd naar {email}",
  "rental.people.notSent": "{email} is toegevoegd, maar de e-mail kon niet worden verstuurd",
  "rental.people.none": "Nog niemand van deze klant heeft een account",
  "rental.people.pending": "Uitgenodigd — nog geen wachtwoord",
  "rental.people.invitedBy": "Uitgenodigd door {name}, {when}",
  "rental.people.makeMain": "Hoofdcontactpersoon maken",
  "rental.people.remove": "Verwijderen",
  "rental.people.removeOf": "{name} verwijderen",
  "rental.people.removeConfirm": "De toegang van {name} verwijderen? Deze persoon kan dan niet meer inloggen op de evenementen van deze klant.",
  "rental.people.removed": "Toegang verwijderd",
  "rental.people.saved": "Opgeslagen",
  "rental.people.failed": "Niet opgeslagen",
  "rental.portal.myEvents": "Mijn evenementen",
  "rental.portal.people": "Personen",
  "rental.portal.nav": "Klantweergave",
  "rental.portal.elsewhere": "Wisselen",
  "rental.portal.noEvents": "Nog geen evenementen om te tonen",
  "rental.portal.noSite": "Dit evenement heeft geen locatie meer",
  "rental.portal.viewAsClient": "Bekijken als klant",
  "rental.portal.previewBar": "U kijkt als de klantpersonen van {customer} — alleen lezen",
  "rental.portal.previewBarNobody": "Wat de klantpersonen van {customer} zien zodra ze zijn uitgenodigd — alleen lezen",
  "rental.portal.backToEvent": "Terug naar het evenement",
  "rental.portal.hiddenRequested": "De klant ziet dit evenement niet: het is aangevraagd",
  "rental.portal.hiddenCancelled": "De klant ziet dit evenement niet: het is geannuleerd",
  "rental.portal.account": "Mijn account",
  "rental.category.nameNeeded": "Typ eerst een naam voor de categorie",
  "rental.portal.devBanner": "Dit product is nog volop in ontwikkeling en staat open voor feedback",
  "rental.item.addHow": "Hoe toevoegen",
  "rental.item.fromDashboard": "Uit het dashboard",
  "rental.item.byHand": "Handmatig",
  "rental.item.brand": "Merk",
  "rental.item.allBrands": "Alle merken",
  "rental.item.browseQ": "Naam, serienummer of MAC",
  "rental.item.browseHint": "Een deel is genoeg, zoals RX",
  "rental.item.found": { one: "{count} apparaat gevonden", other: "{count} apparaten gevonden" },
  "rental.item.tooMany": "De eerste {shown} van {total} getoond: verfijn het filter voor de rest",
  "rental.item.selectAll": "Alles selecteren ({count})",
  "rental.item.selectNone": "Selectie wissen",
  "rental.item.addCount": { one: "{count} item toevoegen", other: "{count} items toevoegen" },
  "rental.item.addedMany": { one: "{count} item toegevoegd", other: "{count} items toegevoegd" },
  "rental.item.chooseDevices": "Vink eerst de apparaten aan die u wilt toevoegen",
  "rental.item.remove": "Verwijderen",
  "rental.item.removeOf": "{name} verwijderen",
  "rental.item.removeConfirm": "{name} verwijderen? Een item dat nooit naar een evenement is geweest, wordt verwijderd; een item dat wel mee is geweest, wordt afgeschreven en houdt zijn geschiedenis.",
  "rental.item.deleted": "Item verwijderd",
  "rental.item.retiredDone": "Item afgeschreven: de geschiedenis blijft bewaard",
  "rental.item.showRetired": "Afgeschreven tonen",
  "rental.history.item.delete": "Item verwijderd",
  "rental.event.remove": "Evenement verwijderen",
  "rental.event.removeConfirm": "Het evenement {name} verwijderen? De regels, wat er mee ging en terugkwam, de site, de opmerkingen bij apparaten en de grafieken worden definitief verwijderd. Inhuur ervoor blijft, zonder het evenement.",
  "rental.event.removed": "Evenement verwijderd",
  "rental.event.removeFailed": "Het evenement is niet verwijderd",
  "rental.event.removableFrom": "Kan worden verwijderd vanaf {date}",
  "rental.portal.push": "Pushmelding wanneer apparatuur bij mijn evenement offline gaat",
  "rental.portal.pushNeedsApp": "Hiervoor is de Velanox-app nodig",
  "rental.portal.pushRefused": "Pushmeldingen zijn niet toegestaan op deze telefoon",
  "rental.scan.unsentConfirm": {"one": "1 scan is nog niet verzonden. Toch afmelden? Deze gaat dan verloren.", "other": "{count} scans zijn nog niet verzonden. Toch afmelden? Ze gaan dan verloren."},
  "rental.scan.summaryTitle": "Scans verzonden",
  "rental.scan.summary": "{loaded} geladen, {returned} teruggezet, {refused} geweigerd",
  "rental.scan.unknownCount": {"one": "1 code hoorde bij niets", "other": "{count} codes hoorden bij niets"},
  "rental.scan.dismiss": "Sluiten",
  "rental.scan.open": "Scannen",
  "rental.scan.nfc": "NFC",
  "rental.scan.title": "Scannen voor {name}",
  "rental.scan.torch": "Lamp",
  "rental.scan.done": "Klaar",
  "rental.scan.sending": "Versturen…",
  "rental.scan.waiting": "Wacht op de verbinding",
  "rental.scan.unknown": "hoort bij niets",
  "rental.scan.loadedRow": "{name} · geladen",
  "rental.scan.returnedRow": "{name} · teruggezet",
  "rental.scan.noCamera": "De camera is niet toegestaan voor de app: sta deze toe in de instellingen van de telefoon",
  "rental.scan.hint": "Houd codes in beeld",
  "rental.scan.hintNfc": "Houd codes in beeld, of een tag tegen de telefoon",
  "rental.scan.nfcPrompt": "Houd een tag tegen de bovenkant van de iPhone",
  "rental.tag.of": "Tag van {name}",
  "rental.tag.save": "Tag opslaan",
  "rental.tag.hold": "Houd de tag tegen de telefoon",
  "rental.tag.writeFailed": "De tag kon niet worden beschreven: houd deze stil en probeer het opnieuw",
  "rental.tag.scanTitle": "Een label scannen",
  "rental.tag.scanHint": "Houd de code van het label in beeld",
  "rental.tag.none": "Geen artikel heeft deze tag",
  "rental.tag.looking": "De tag wordt opgezocht…",
  "rental.scan.sameItem": "zelfde artikel, al geteld",
  "rental.scan.unsentConfirmServer": {"one": "1 scan is nog niet verzonden. Toch een andere server kiezen? Deze gaat dan verloren.", "other": "{count} scans zijn nog niet verzonden. Toch een andere server kiezen? Ze gaan dan verloren."},
  "rental.people.clientExport": "Klanten mogen exporteren",
  "rental.people.clientExportHint": "De klantpersonen mogen dit evenement vanaf hun pagina downloaden: de apparaten met hun notities, de grafieken en de lijst met personen",
  "rental.people.exportOn": "Klanten mogen dit evenement exporteren",
  "rental.people.exportOff": "Klanten mogen dit evenement niet meer exporteren",
  "rental.planning.exportNote": "vrij per dag; een min-getal is het aantal tekort",
  "rental.portal.readOnly": "Alleen-lezen — wat deze apparatuur meldt",
  "rental.portal.deviceGone": "Dit apparaat is niet meer bij uw evenement",
  "rental.portal.noStored": "Voor dit apparaat is nog niets opgeslagen",
  "rental.portal.sinceLoaded": "Vanaf {when}, toen het voor dit evenement uitging",
  "rental.portal.unnamedLink": "Naamloze verbinding",
  "rental.portal.range1h": "1 u",
  "rental.portal.range6h": "6 u",
  "rental.portal.cellular": "Mobiel netwerk",
  "rental.portal.poe": "PoE",
  "rental.portal.standby": "Stand-by",
  "rental.portal.unnamedDevice": "Naamloos apparaat",
  "rental.pings.title": "Gepingde apparaten",
  "rental.pings.portalTitle": "Uw apparaten",
  "rental.pings.intro": "Gepingd op hun IP-adres via de MikroTik-radio's op uw evenement zolang het loopt.",
  "rental.pings.companyIntro": "De apparaten van de klant, gepingd op hun IP-adres via de MikroTik-radio's die op het lopende evenement van de klant staan — alleen dat evenementnetwerk.",
  "rental.pings.name": "Naam",
  "rental.pings.ip": "IP-adres",
  "rental.pings.state": "Status",
  "rental.pings.rtt": "Reactietijd",
  "rental.pings.answered": "Laatst geantwoord",
  "rental.pings.foundThrough": "Gevonden via",
  "rental.pings.status.ONLINE": "Online",
  "rental.pings.status.OFFLINE": "Offline",
  "rental.pings.status.NO_ANSWER": "Geen antwoord",
  "rental.pings.status.UNKNOWN": "Niet gecontroleerd",
  "rental.pings.add": "Apparaat toevoegen",
  "rental.pings.edit": "Bewerken",
  "rental.pings.save": "Opslaan",
  "rental.pings.remove": "Verwijderen",
  "rental.pings.removeConfirm": "{name} verwijderen uit de gepingde apparaten?",
  "rental.pings.pingNow": "Handmatig pingen",
  "rental.pings.pingAll": "Alles pingen",
  "rental.pings.none": "Nog geen apparaten",
  "rental.pings.mode": "Pingcontroles",
  "rental.pings.mode.EVERY_30S": "Elke 30 seconden",
  "rental.pings.mode.EVERY_MINUTE": "Elke minuut",
  "rental.pings.mode.EVERY_5_MINUTES": "Elke 5 minuten",
  "rental.pings.mode.ON_OPEN": "Alleen als ik het dashboard open",
  "rental.pings.mode.OFF": "Uit",
  "rental.pings.changedBy": "Gewijzigd door {name}, {when}",
  "rental.pings.onOpenLine": "Alleen gecontroleerd zolang deze pagina open is (hoogstens elke 5 minuten)",
  "rental.pings.notOn": "Nu niet gecontroleerd: geen van de evenementen van de klant loopt",
  "rental.pings.answering": "{count} van {total} antwoorden",
  "rental.pings.failed": "Dat is niet gelukt",
  "rental.portal.pushPings": "Push als mijn apparaten niet meer antwoorden",
  "rental.pings.notOnClient": "Nu niet gecontroleerd: geen van uw evenementen loopt",
  "rental.pings.appliesNow": "Nu gecontroleerd als {mode}: de meest frequente instelling van uw lopende evenementen",
  "rental.event.openSite": "Locatie openen",
}

export default rental
